import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionPanel',
  props: {
    expand: { type: Boolean, default: true },
    useDefaultExpansionBtn: { type: Boolean, default: true }
  },
  emits: ["expansion"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'expansion', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { expand: boolean, useDefaultExpansionBtn: boolean };

const expander = ref<null | any>(null);



const {} = useContext();

const panel = computed(() => {
  return props.expand ? [0] : [];
});

function onExpansionChange() {
  emit('expansion', expander.value?.isActive);
}

return { __sfc: true,expander, emit, props, panel, onExpansionChange }
}

})